module.exports = __webpack_public_path__ + "img/profile-icon.b4837001.svg";